export default __webpack_public_path__ + "static/media/crown.80111b7d.svg";